import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'employee-onboarding',
  children: {
    welcome: { path: 'welcome' },
    onboardingTasks: {
      path: 'onboarding',
      children: {
        taskDetail: { path: 'tasks/:taskId' },
      },
    },
  },
} as const satisfies Location
